export function prefersReducedMotion(): boolean {
    return typeof matchMedia === 'function'
        && matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function easeOutCubic(t: number): number {
    const x = clamp01(t);
    return 1 - (1 - x) ** 3;
}

export function easeOutBack(t: number): number {
    const x = clamp01(t);
    const c = 1.70158;
    return 1 + (c + 1) * (x - 1) ** 3 + c * (x - 1) ** 2;
}

export function pulse(t: number): number {
    return Math.sin(clamp01(t) * Math.PI);
}

export function clamp01(t: number): number {
    return Math.min(Math.max(t, 0), 1);
}

export function lerp(from: number, to: number, t: number): number {
    return from + (to - from) * t;
}
